import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/portal/dashboard/Dashboard";
import Autorization from "./pages/portal/autorization/Autorization";
import NotFound from "./pages/NotFound";
import { useSelector } from "react-redux";
import ConsultasAut from "./pages/portal/consultasaut/ConsultasAut";
import ConsultFecha from "./pages/portal/consultasfecha/ConsultFecha";
import ProtectedRoutes from "./routes/ProtectedRoutes";
import ReportsAuth from "./pages/portal/reports/ReportsAuth";
import LoginForm from "./pages/LoginForm";
import ViewManualAuth from "./pages/portal/reports/ViewManualAuth";
import ReportsVolets from "./pages/portal/reports/ReportsVolets";
import Nucleofamiliar from "./pages/portal/nucleofamiliar/Nucleofamiliar";
import ReprintPdfReport from "./components/portal/PrintFiles/ReprintPdfReport";
import ReprintTicketReport from "./components/portal/PrintFiles/ReprintTicketReport";
import ViewerTicketReport from "./components/portal/PrintFiles/ViewerTicketReport";
import PresentarQuejas from "./pages/portal/quejas/PresentarQuejas";

function App() {
  
  const { usuario, token } = useSelector((state) => state.user);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginForm />} />
        <Route element={<ProtectedRoutes user={usuario} token={token} />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/authorization" element={<Autorization />} />
          <Route path="/consultaut" element={<ConsultasAut />} />
          <Route path="/consultdata" element={<ConsultFecha />} />
          <Route path="/nucleofamiliar" element={<Nucleofamiliar />} />
          <Route path="/presentarquejas" element={<PresentarQuejas />} />
          <Route path="/reports" element={<ReportsAuth />} />
          <Route path="/reportvolet" element={<ReportsVolets />} />
          <Route path="/reprintreport" element={<ReprintPdfReport />} />
          <Route path="/reprintticket" element={<ReprintTicketReport />} />
          <Route path="/reportticket" element={<ViewerTicketReport />} />
          <Route path="/manual" element={<ViewManualAuth />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
